import styled from 'styled-components';

export const FrontendLinearBg = styled.div`
  background: linear-gradient(
    ${props => props.theme.colors.linear.start},
    ${props => props.theme.colors.linear.end}
  );
  color: #fff;
`;
